module.exports = __webpack_public_path__ + "static/media/generarcontrato.60328e1d.svg";